import { P_TER } from '@lba-dev/package.local-globals/propositionStatus';
import {
  FACTENV
} from '@lba-dev/package.local-globals/paymentMethods';
import {
  P_ACCEPTED,
  P_REJECTED
} from '@lba-dev/package.local-globals/isValidStatus';
import { fromJS } from 'immutable';

import api from '../api';
import notifSystem from '../notifSystem';
import { setDialog } from './dialog';
import Money from '../utils/Money';
import { checkIfLeroyMerlinLead, checkInfosFacturation } from './verifications';
import { custom, objectDialog } from '../utils/DialogsCheck';
import store from '../store';
import { updateInter, openVerifDialogFromProposition } from './inter';

const updateProposition = ({
  valid, interId, cb, motifCancel, verifData
}) => api
  .one('propositions', interId)
  .custom('updateProposition')
  .post({
    valid,
    ...(motifCancel ? { motifCancel } : {}),
    ...(verifData ? { verifData } : {}),
  })
  .then(() => {
    if (cb) {
      cb();
    }
    notifSystem.success('Message', 'La proposition a bien été mise à jour');
  })
  .catch(e =>
    notifSystem.error(
      e.name,
      e.message === 'Not Acceptable'
        ? 'Coordonnées de facturation incomplètes'
        : e.message
    )
  );

export async function checkProposition(
  valid,
  {
    intervention: {
      announcedPrice = 0,
      announcedPriceMax = 0,
      proposition = {},
      id,
      flexPrice,
      ...inter
    },
    verifData
  },
  type,
  cb
) {
  const defaultText = objectDialog[custom]({
    hasTextField: true,
    warningMessage: 'VU PAR L\'ARTISAN',
    setDialog,
    cb: ({ motifCancel }, close) => {
      updateProposition({ valid, interId: id, cb, motifCancel });
      close();
    },
  });
  if (proposition && valid !== proposition.isValid) {
    if (proposition.status === P_TER && type !== 'Refus') {
      if (valid && flexPrice &&
        !(proposition.finalPrice >= announcedPrice &&
        proposition.finalPrice <= announcedPriceMax)) {
        return notifSystem.error(
          'Veuillez modifier le prix',
          `Le prix proposé (${
            Money.toString(proposition.finalPrice, true)}) n'est pas ` +
            `dans la fourchette de prix (${
              Money.toString(announcedPrice, true)} - ${
              Money.toString(announcedPriceMax, true)})`
        );
      }
      if (
        valid && !flexPrice && announcedPrice &&
        proposition.finalPrice !== announcedPrice
      ) {
        return notifSystem.error(
          'Veuillez modifier le prix',
          `Le prix proposé (${
            Money.toString(proposition.finalPrice, true)}) est ` +
          `différent du prix final (${
            Money.toString(announcedPrice, true)})`
        );
      }
      if (
        (!inter.onSitePayment || proposition.paymentMethod === FACTENV) &&
        checkInfosFacturation(inter.billing).length
      ) {
        const errors = checkInfosFacturation(inter.billing);
        return notifSystem.error(
          'Coordonnées de facturation',
          `${errors.join(', ')} incomplets`
        );
      }
      if (
        (checkIfLeroyMerlinLead(fromJS(inter)) &&
        (!inter.notation || inter.notation.client.note < 4))
      ) {
        return notifSystem.error(
          'Note de client',
          'Le client doit avoir une note de 4/5'
        );
      }
    }
    if (valid === P_REJECTED) {
      return store.dispatch(defaultText.callBack());
    } else if (
      proposition &&
      proposition.status === P_TER
    ) {
      await updateInter(inter._id, { proposition });
    }
    return updateProposition({
      valid,
      interId: id,
      cb,
      motifCancel: null,
      verifData
    });
  }
  return false;
}

export async function openPropositionDialog(inter, cb) {
  if (typeof inter === 'number') {
    inter = await api.interventions.get(inter)
      .then(res => res.body().data());
  }
  return store.dispatch(
    setDialog({
      name: 'DialogProposition',
      open: true,
      dialogProps: {
        title: 'Mise à jour du partenaire',
        maxWidth: 'lg',
      },
      contentProps: { inter },
      actions: [
        {
          children: 'Valider',
          onClick: (data, close) => {
            close();
            const updatedInter = {
              ...inter,
              proposition: data.inter.proposition,
            };

            if (
              inter.demande &&
              inter.demande.source === 'BIEN ETRE ASSISTANCE'
            ) {
              updatedInter.noPaymentReceived = true;
              updatedInter.finalPrice = data.inter.proposition.finalPrice;
              updatedInter.paymentMethod = data.inter.proposition.paymentMethod;
              return openVerifDialogFromProposition(
                store.getState().connectedUser,
                updatedInter,
                (verifData) =>
                  checkProposition(
                    P_ACCEPTED,
                    { intervention: updatedInter, verifData },
                    'Accept',
                    cb
                  )
              );
            }
            return checkProposition(
              P_ACCEPTED,
              { intervention: updatedInter },
              'Accept',
              cb
            )

          },
          color: 'primary',
        },
        {
          children: 'Refuser',
          onClick: (_, close) => {
            close();
            checkProposition(P_REJECTED, { intervention: inter }, 'Refus', cb);
          },
          color: 'secondary',
        },
      ],
    })
  );
}
